<template lang="pug">
  ul.menu(:class="menuClass")
      li.menu__item
          router-link.menu__link(to='/inside-partners' ) {{ tr.menu.title_1 }}
      li.menu__item
          router-link.menu__link(to='/inside-team' ) {{ tr.menu.title_2 }}
      li.menu__item
          router-link.menu__link(to='/inside-shop' ) {{ tr.menu.title_3 }}
</template>

<script>
export default {
  data () {
    return {
      section: 'header'
    }
  },
  props: {
    white: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    menuClass () {
      return this.white ? 'menu__white' : null
    }
  }
}
</script>

<style lang="scss">
  .menu {
    flex-basis: 530px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;

    margin-top: 0;
    margin-bottom: 0;
    padding-left: 0;

    list-style: none;
    @media(max-width: 1366px){
      flex-basis: 410px;
      margin-left: 30px;
    }

    &__link {
      color: #000;

      // border-bottom:
      // text-decoration: none;
    }

    &__white {
      .menu__link {
        color: #ffffff;

        // border-bottom:
        // text-decoration: none;
      }
    }

    &_text-decoration_none {
      text-decoration: none;
    }
  }

  .menu__link.router-link-active {
    opacity: .5;
    text-decoration: none;
  }
</style>
